import { parseTime, toThousands } from '@/utils/index'

export const numFilter = function(value: any, type: string){
    // const realVal = ((value || 0) / 100).toFixed(2)
    return toThousands(value, type)
}

export const timeFilter = function(value: any, str: string){
    return parseTime(value, str)
}